import { route } from "../router/route";

const menuListConst = [
  {
    title: "홈",
    value: route.home,
    subMenu: [],
  },
  {
    title: "쇼핑",
    value: route.shopping,
    subMenu: [
      { title: "상품관리", value: route.shopping_product },
      { title: "판매관리", value: route.shopping_sell },
      { title: "멤버십 상품관리", value: route.shopping_membership_product },
      { title: "멤버십 판매관리", value: route.shopping_membership_sell },
      { title: "후기관리", value: route.shopping_review },
    ],
  },
  {
    title: "회원관리",
    value: route.user,
    subMenu: [
      { title: "회원정보", value: route.user_info },
      { title: "멤버십 회원정보", value: route.user_membership_info },
      { title: "멤버십 대기명단", value: route.user_membership_waiting_list },
      { title: "무료 PDF 신청 명단", value: route.user_pdf_application_list },
      { title: "운영진 설정", value: route.user_admin },
      { title: "구매제한 회원", value: route.user_purchase_limit },
      { title: "탈퇴 회원", value: route.user_withdraw },
    ],
  },
  {
    title: "통계",
    value: route.statistics,
    subMenu: [
      { title: "홈", value: route.statistics_home },
      { title: "매출", value: route.statistics_sales },
      { title: "기간별 분석", value: route.statistics_period },
      { title: "유입 사이트", value: route.statistics_inflow_site },
      { title: "유입 검색어", value: route.statistics_inflow_search },
      { title: "방문자", value: route.statistics_visitor },
      { title: "많이 방문한 페이지", value: route.statistics_most_visited },
      { title: "시간대별 조회수", value: route.statistics_time },
      { title: "성별·연령별 조회수", value: route.statistics_gender_age },
      { title: "멤버십 분석", value: route.statistics_analysis },
      { title: "멤버십 해지분석", value: route.statistics_cancel },
    ],
  },
  {
    title: "운영 관리",
    value: route.operation,
    subMenu: [
      {
        title: "쿠폰",
        value: route.operation_coupon,
      },
      {
        title: "메시지 보내기",
        value: route.operation_message,
      },
      {
        title: "공지사항 관리",
        value: route.operation_notice,
      },
      {
        title: "포인트 관리",
        value: route.operation_point,
      },
      {
        title: "레벨 설정 관리",
        value: route.operation_level,
      },
      {
        title: "자주 묻는 질문 관리",
        value: route.operation_faq,
      },
      {
        title: "1:1 문의 내역 관리",
        value: route.operation_ask,
      },
      {
        title: "팝업/배너 관리",
        value: route.operation_popup_banner,
      },
      {
        title: "약관 관리",
        value: route.operation_terms,
      },
    ],
  },
  {
    title: "일급비밀 관리",
    value: route.secret,
    subMenu: [
      {
        title: "일급비밀 상세페이지",
        value: route.secret_detail,
      },
      {
        title: "멤버십 QnA 관리",
        value: route.secret_qna,
      },
      {
        title: "자료창고 관리",
        value: route.secret_archive,
      },
    ],
  },
  {
    title: "지식상점 관리",
    value: route.knowledge,
    subMenu: [
      {
        title: "지식상점 홈 배너",
        value: route.knowledge_banner,
      },
      {
        title: "Vu: 관리",
        value: route.knowledge_vu,
      },
      {
        title: "커리큘럼 관리",
        value: route.knowledge_curriculum,
      },
      {
        title: "첫 방문이라면? 관리",
        value: route.knowledge_first_visit,
      },
    ],
  },
  {
    title: "커뮤니티 관리",
    value: route.community,
    subMenu: [
      {
        title: "커뮤니티 관리",
        value: route.community_management,
      },
      {
        title: "라이팅크루가 처음이라면?",
        value: route.community_first,
      },
    ],
  },
  {
    title: "멤버십 전용 관리",
    value: route.crew,
    subMenu: [
      {
        title: "멤버십 가이드",
        value: route.crew_guide,
      },
      {
        title: "라이팅링크",
        value: route.crew_link,
      },
    ],
  },
];

export default menuListConst;
